import { addResetToColumnChooser } from "../../framework/tabulars";
import { optionsToolbar } from "../../utils/devextreme_utils";

/**
 * @param {Object} options
 * @param {boolean} options.resetColumnsKey
 *  Add an undo button to the column chooser popup. If not set, the reset button does not appear.
 *  The value should be the same as the `storageKey` provided to the `localStoragePlugin`.
 *
 * @returns {import("../datagrid").Plugin}
 */
export function columnChooserPlugin(options = {}) {
  return ($container) => {
    const $trigger = $container.querySelector(".js-datagrid-column-chooser");
    if (!$trigger) {
      console.warn("Column chooser could not be found");
    }

    return {
      id: "columnChooser",
      options: optionsToolbar,

      onDataGridCreated() {
        $trigger.addEventListener("click", () => {
          this.showColumnChooser();

          if (options.resetColumnsKey) {
            addResetToColumnChooser(options.resetColumnsKey);
          }
        });
      },
    };
  };
}
